import type { ComponentType, SVGProps } from 'react';

type LottieSource = object;
export type AnswerBoxSource = LottieSource | string;

type ThemeLottieVariants = {
	mobile: LottieSource;
	tablet?: LottieSource;
	tabletPortrait?: LottieSource;
	tabletLandscape?: LottieSource;
	desktop: LottieSource;
};

export type LaneChooserTheme = {
	key: LANE_CHOOSER_THEME_KEYS;
	images: {
		sideElements: string[];
		character: {
			jump: ComponentType<SVGProps<SVGSVGElement>>;
		};
	};
	animations: {
		answerBoxes: {
			left: AnswerBoxSource;
			middle: AnswerBoxSource;
			right: AnswerBoxSource;
		};
		character: {
			default: LottieSource;
			correct: LottieSource;
		};
		endScreen: {
			success: ThemeLottieVariants;
			failed: ThemeLottieVariants;
		};
		startScreen: {
			mapUnfold: LottieSource;
			background?: ThemeLottieVariants;
		};
	};
};

export enum LANE_CHOOSER_THEME_KEYS {
	LAKE = 'lake',
	FOREST = 'forest',
	MOUNTAIN = 'mountain',
	DESERT = 'desert',
	PARK = 'park',
}

export const defaultThemeKey = LANE_CHOOSER_THEME_KEYS.LAKE;
